/* @ngInject */

export default (
  $rootScope,
  $scope,
  $q,
  organizationService,
  changesService,
  navigationService,
  uiService,
  OrganizationEnterprise,
  webpage
) => {
  $scope.Model = {
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    organizationService
      .readOrganization({ id: $rootScope.CurrentOrganization.id })
      .then((data) => {
        // Overwrite $rootScope values in case they've reverted to values within Token
        // eslint-disable-next-line no-param-reassign
        $rootScope.CurrentOrganization.enterprise = OrganizationEnterprise.build(
          data.enterprise
        );
      })
      .then(() => {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Professional licenses : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.toggleChanges = () => {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  const saveChanges = () => {
    const organizationData = {
      id: $rootScope.CurrentOrganization.id,
      enterprise: {
        licenses: $rootScope.CurrentOrganization.enterprise.licenses
      }
    };
    return organizationService.updateOrganization(organizationData).then((result) => {
      if (result.status) {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  };

  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);
};
